import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=2355a384&scoped=true&"
import script from "./identification.vue?vue&type=script&lang=js&"
export * from "./identification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355a384",
  null
  
)

export default component.exports